// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "video[data-v-29c78f13]{border-radius:32px}.video[data-v-29c78f13]{aspect-ratio:16/9;background-color:rgba(255,255,255,.3);background-image:url(\"https://static.moele.me/img/subscribe/subscription-ai-remix-2026.260522.jpg\");background-position:center;background-size:cover}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
